/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voices_Manual_Record_LabelInputs */



/**
* | output |
* | --- |
* | "Manual Record" |
*
* @param {Voices_Manual_Record_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voices_manual_record_label = /** @type {((inputs?: Voices_Manual_Record_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voices_Manual_Record_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrement manuel")
	if (locale === "de") return /** @type {LocalizedString} */ ("Manuelle Aufzeichnung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Registrazione manuale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ручная запись")
	if (locale === "es") return /** @type {LocalizedString} */ ("Registro manual")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("手动记录")
	if (locale === "ja") return /** @type {LocalizedString} */ ("手動記録")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मैनुअल रिकॉर्ड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Registro manual")
	return /** @type {LocalizedString} */ ("Manual Record")
});